export interface AddressParts {
  city: string;
  street: string;
  home_number: string;
  apartment_number?: string;
}

export function formatAddressFromParts({ city, street, home_number, apartment_number }: AddressParts): string {
  const normalizedCity = (city ?? "").trim();
  const normalizedStreet = (street ?? "").trim();
  const normalizedHome = (home_number ?? "").trim();
  const normalizedApartment = (apartment_number ?? "").trim();

  const base = `город ${normalizedCity}, ${normalizedStreet}, дом №${normalizedHome}`;
  if (normalizedApartment !== "") {
    return `${base}, квартира №${normalizedApartment}`;
  }
  return base;
}

export interface ParsedAddressParts {
  city: string;
  street: string;
  home_number: string;
  apartment_number?: string;
}

export function parseAddressString(address: string): ParsedAddressParts | null {
  const input = (address ?? "").trim();
  if (!input) return null;

  const re = /^город\s+(.+?),\s+(.+?),\s+дом\s+№\s*(.+?)(?:,\s*квартира\s+№\s*(.+))?$/i;
  const match = input.match(re);
  if (!match) return null;

  const [, cityRaw, streetRaw, homeRaw, apartmentRaw] = match;
  const city = (cityRaw ?? "").trim();
  const street = (streetRaw ?? "").trim();
  const home_number = (homeRaw ?? "").trim();
  const apartment_number = (apartmentRaw ?? "").trim();

  if (!city || !street || !home_number) return null;

  return apartment_number ? { city, street, home_number, apartment_number } : { city, street, home_number };
}
